import { webServiceHost } from '../services/dior';

export const SEND_APPOINTMENT_URL = {
  development: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostRequestAppointmentTest`,
  test: `hhttps://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostRequestAppointmentTest`,
  preProduction: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostRequestAppointmentTest`,
  production: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/prod/PostRequestAppointment`
};

export const FETCH_MOTIVES_URL = {
  development: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/ListContactReasons`,
  test: `/fixtures/motives.json`,
  preProduction: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/ListContactReasons`,
  production: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/prod/ListContactReasons`
};

export const SEND_SHARE_URL = {
  development: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostSharePosTest`,
  test: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostSharePosTest`,
  preProduction: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/beta/PostSharePosTest`,
  production: `https://tpc33of0na.execute-api.eu-west-1.amazonaws.com/prod/PostSharePos`
};

export const SEND_NEWSLETTER_URL = {
  development: `https://preprod.dior.com/couture/ecommerce/newsletter/index/subscribeHeader?___store=default`,
  test: `https://preprod.dior.com/couture/ecommerce/newsletter/index/subscribeHeader?___store=default`,
  preProduction: `${webServiceHost}/couture/ecommerce/newsletter/index/subscribeHeader?___store=default`,
  production: `${webServiceHost}/couture/ecommerce/newsletter/index/subscribeHeader?___store=default`
};


// WEBPACK FOOTER //
// ./src/settings/popin.js